import { Heading } from "@/components/typography/Heading";
import { Text } from "@/components/typography/Text";

export default function FAQs() {
  return (
    <div className="px-12">
      <Heading level={2} size="section" className="w-full pb-2 text-center">
        أسئلة شائعة
      </Heading>
      <div className="gradient mx-auto my-0 h-1 w-48 rounded-t py-0 opacity-25" />

      <div>
        <div className="mt-12">
          <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:space-y-0 sm:gap-x-6 sm:gap-y-16 lg:gap-x-10">
            <div>
              <dt className="text-base leading-7 font-semibold text-gray-900">من نحن؟</dt>
              <Text as="dd" className="mt-2">
                نحن مؤسسة <strong>أوراق</strong> لتقنية المعلومات، نعمل على تطوير خدمات تقنية لخدمة العوائل، رقم السجل
                التجاري: 1010744065
              </Text>
            </div>
            <div>
              <dt className="text-base leading-7 font-semibold text-gray-900">
                هل بيانات عائلتي محمية في الموقع ولا يمكن لأحد الاطلاع عليها؟
              </dt>
              <Text as="dd" className="mt-2">
                <strong className="text-green-500">نعم بالتأكيد</strong>، نحرص كثيرًا على خصوصية عائلتكم، فبياناتكم بعد
                إدخالها لن تظهر إلا لمسؤولي العائلة، ويمكنكم لاحقًا في الإعدادات السماح لأفراد العائلة بالاطلاع على الشجرة.
              </Text>
            </div>
            <div>
              <dt className="text-base leading-7 font-semibold text-gray-900">هل يمكنني تحميل بيانات عائلتي؟</dt>
              <Text as="dd" className="mt-2">
                نعم يمكنك تحميل جميع بيانات عائلتك في أي وقت بصيغة إكسل.
              </Text>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
